/* Core & libraries */
import React, { useState } from "react";
import { useTheme } from "react-jss";
import { Link, useNavigate } from "react-router-dom";

import { FormattedMessage } from "react-intl";

/* Helpers, constants, custom methods, internal libraries */
import { useLocaleContext } from '../../../../../contexts/localeContext';
import { formatDate, getTicketStatusDescription, renderAmount } from '../../../../../helpers/reportsHelper';

/* Components */
import UCGrid from "../../../../ucgrid";
import ReportsNoBookings from "../../../../reportsNoBookings"

/* Styles */
import styles from "./styles.js"

// to be changed for booking grid

const getCouponStatusDescription = (couponStatus) => {
  switch (couponStatus) {
    case 1:
      return <FormattedMessage id="couponsGrid.couponStatus1"/>
    case 0:
      return <FormattedMessage id="couponsGrid.couponStatus0"/>
    case -1:
      return <FormattedMessage id="couponsGrid.couponStatusMinus1"/>
    case "E":
      return <FormattedMessage id="couponsGrid.couponStatusE"/>
    case "F":
      return <FormattedMessage id="couponsGrid.couponStatusF"/>
    case "O":
      return <FormattedMessage id="couponsGrid.couponStatusO"/>
    case "U":
      return <FormattedMessage id="couponsGrid.couponStatusU"/>
    default:
      return couponStatus
  }
}

const CouponsGrid = (props) => {
  const {gridOptions, setGridOptions, couponsResponse, onRowClick, handleSort, defaultSort} = props;
  const theme = useTheme();
  const classes = styles({ theme });
  const navigate = useNavigate();
  const globalLocale = useLocaleContext();

  const [selectedRow, setSelectedRow] = useState(null);

  return (
    <div className={classes.ticketsGrid}>
      <UCGrid
        gridName="couponsGrid"
        data={couponsResponse?.results}
        columns={couponsResponse?.columns}
        actions={couponsResponse?.actions}
        handlePageChange={(page) => {
          setGridOptions({
            ...gridOptions,
            page,
          });
          page > 1
            ? navigate(`/app/reports/coupons?page=${page}`)
            : navigate(`/app/reports/coupons`);
        }}
        setSelectedRow={setSelectedRow}
        spinner="couponsGridSpinner"
        customColumns={{
          couponStatus : (row) => {
            return row.couponStatus ? getCouponStatusDescription(row.couponStatus) : '-';
          },
          issueDateTime: (row) => (
            <div className={classes.link}>{formatDate(row?.issueDateTime, globalLocale)}</div>
          ),
          departureDateLocal: (row) => (
            <div className={classes.link}>{formatDate(row?.departureDateLocal, globalLocale)}</div>
          ),
          arrivalDateLocal: (row) => (
            <div className={classes.link}>{formatDate(row?.arrivalDateLocal, globalLocale)}</div>
          ),
          ticketStatus : (row) => {
            return row.ticketStatus ? getTicketStatusDescription(row.ticketStatus) : '-';
          },
        }}
        columnCustomWidth={{
          scheduledArrivalBySegment: '200px !important',
          firstName: '200px !important',
          lastName: '200px !important',
          middleName: '200px !important',
          flightNumber: '200px !important',
          departureDateLocal: '240px !important',
          arrivalDateLocal: '250px !important',
          vendorCode: '200px !important',
          arrivalAirport: '200px !important',
          ticketNumber: '200px !important',
          confirmationCode: '200px !important',
          departureAirport: '200px !important',
        }}
        noDataComponent={<ReportsNoBookings />}
        showHeader={true}
        persistTableHead={false}
        onRowClick={onRowClick}
        handleSort={handleSort}
        defaultSort={defaultSort}
      />
    </div>
  );
}

export default CouponsGrid;
